import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@beweegbaas/ui";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { useSchoolLayoutData } from "#/modules/generic.user/use-schools";
import { useSchoolParams } from "#/modules/util.helpers/route-href";
import {
  pathnameWithSchoolyear,
  schooljaarRangeFromAdminModel,
} from "#/modules/util.helpers/utils.schoolyear-path";
import { m } from "#/paraglide/messages";

/**
 * Schooljaar picker shown in the header for admins. Rebuilds the current pathname with the chosen
 * schoolyear segment (or removes it for "current"). Ported from portal's `AdminSchooljaarSelect`;
 * reads `isAdmin` + `schooljaren` from the `$school` layout loader data.
 */
export function AdminSchooljaarSelect() {
  const layoutData = useSchoolLayoutData();
  const isAdmin = layoutData?.isAdmin ?? false;
  const schooljaren = layoutData?.schooljaren ?? [];
  const { locale, school, schoolyear } = useSchoolParams();
  const navigate = useNavigate();
  const location = useLocation();

  if (!isAdmin || schooljaren.length === 0 || !school) {
    return null;
  }

  const selectValue = schoolyear ?? "";

  return (
    <Select
      value={selectValue}
      onValueChange={(value) => {
        if (value === null) {
          return;
        }
        const next = value === "" ? undefined : value;
        void navigate({
          href:
            pathnameWithSchoolyear({
              pathname: location.pathname,
              locale,
              school,
              schoolyear: next,
            }) + location.searchStr,
        });
      }}
    >
      <SelectTrigger
        className="shrink-0"
        aria-label={m["admin.scholen.schooljaar_select.aria_label"]()}
      >
        <SelectValue placeholder={m["admin.scholen.schooljaar_select.default_option"]()} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="">{m["admin.scholen.schooljaar_select.default_option"]()}</SelectItem>
        {schooljaren.map((sj) => {
          const range = schooljaarRangeFromAdminModel(sj);
          return (
            <SelectItem key={sj.id} value={range}>
              {sj.name}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
